// Complete translations for COCON SACRÉ 2026 - Explorer Page
// /cocon-sacre-2026/explorer (CoconSacre2026.jsx)

export const explorerTranslations = {
  // META TAGS
  meta: {
    title: {
      fr: "COCON SACRÉ 2026 – Retraite Transformatrice Bali | Nage Prie Rayonne",
      en: "COCON SACRÉ 2026 – Transformational Retreat in Bali | SWIM · PRAY · RADIATE ·"
    },
    description: {
      fr: "Retraite initiatique à Bali, Ubud et Borobudur. Une expérience signature de transformation profonde. Nage · Prie · Rayonne. Mai-Juin 2026.",
      en: "An initiatory retreat across Bali and Borobudur. A signature transformational journey. SWIM · PRAY · RADIATE · May–June 2026."
    }
  },

  // WHY BALI SECTION
  whyBali: {
    category: { fr: "Le lieu", en: "The place" },
    title: { fr: "Pourquoi Bali ?", en: "Why Bali?" },
    subtitle: { fr: "Là où le sacré est vivant", en: "Where the sacred is alive" },
    p1: { fr: "Je vis à Bali depuis 2011.", en: "I have lived in Bali since 2011." },
    p2: { 
      fr: "Pendant longtemps, j'y ai habité sans vraiment la voir.\nJe marchais sur cette terre sans en percevoir la profondeur.\nJe respirais son air sans entendre ce qu'il murmurait.", 
      en: "For a long time, I lived here without truly seeing it.\nI walked on this land without perceiving its depth.\nI breathed its air without hearing what it whispered."
    },
    p3: { 
      fr: "Comme beaucoup, je regardais Bali.\nJe ne la rencontrais pas.", 
      en: "Like many, I looked at Bali.\nI did not meet it."
    },
    p4: { fr: "Puis, un jour, quelque chose s'est déplacé.", en: "Then one day, something shifted." },
    p5: { 
      fr: "Un regard différent.\nUne écoute plus fine.\nUne humilité nouvelle.", 
      en: "A different gaze.\nA finer listening.\nA new humility."
    },
    p6: { 
      fr: "J'ai compris que cette île ne se visite pas.\nElle se respecte.\nElle se reçoit.\nElle s'honore.", 
      en: "I understood that this island is not visited.\nIt is respected.\nIt is received.\nIt is honored."
    },
    p7: { 
      fr: "Mama Bali n'est pas un décor exotique.\nC'est une terre vivante.", 
      en: "Mama Bali is not an exotic backdrop.\nIt is a living land."
    },
    p8: { 
      fr: "Une terre de rituels quotidiens.\nDe gestes silencieux.\nD'offrandes déposées avant même que le soleil ne se lève.", 
      en: "A land of daily rituals.\nOf silent gestures.\nOf offerings placed before the sun even rises."
    },
    p9: { 
      fr: "Ici, le sacré ne se montre pas.\nIl se pratique.", 
      en: "Here, the sacred is not displayed.\nIt is practiced."
    },
    p10: { fr: "Depuis, ma posture a changé.", en: "Since then, my posture has changed." },
    p11: { 
      fr: "Je ne viens plus prendre.\nJe viens rendre.", 
      en: "I no longer come to take.\nI come to give back."
    },
    p12: { 
      fr: "Par la gratitude.\nPar la transmission.\nPar le respect.", 
      en: "Through gratitude.\nThrough transmission.\nThrough respect."
    },
    p13: { 
      fr: "Nous ne venons pas consommer Bali.\nNous ne venons pas accumuler des images.", 
      en: "We do not come to consume Bali.\nWe do not come to accumulate images."
    },
    p14: { 
      fr: "Nous venons entrer en relation.\nHonorer.\nRemercier.\nOffrir autant que nous recevons.", 
      en: "We come to enter into relationship.\nTo honor.\nTo thank.\nTo offer as much as we receive."
    },
    p15: { fr: "Ce voyage est un échange.", en: "This journey is an exchange." },
    p16: { 
      fr: "Un échange avec la terre.\nAvec son peuple.\nAvec ses traditions vivantes.", 
      en: "An exchange with the land.\nWith its people.\nWith its living traditions."
    },
    p17: { 
      fr: "Et lorsque l'on entre ainsi dans Bali,\nelle s'ouvre autrement.", 
      en: "And when one enters Bali in this way,\nit opens differently."
    },
    p18: { 
      fr: "Plus doucement.\nPlus profondément.\nPlus véritablement.", 
      en: "More gently.\nMore deeply.\nMore authentically."
    }
  },

  // POSITIONING / LIVING RITUAL SECTION
  positioning: {
    p1: {
      fr: "COCON SACRÉ n'est pas une retraite\npour apprendre à prier.",
      en: "COCON SACRÉ is not a retreat to learn how to pray."
    },
    p2: {
      fr: "Ce n'est pas une accumulation de techniques.\nCe n'est pas une méthode à reproduire.",
      en: "It is not an accumulation of techniques.\nIt is not a method to replicate."
    },
    p3: {
      fr: "C'est une immersion dans le rituel vivant.",
      en: "It is an immersion into living ritual."
    },
    p4: {
      fr: "Un retour aux gestes simples.\nÀ l'offrande déposée avec conscience.\nAu silence habité.\nÀ la présence quotidienne.",
      en: "A return to simple gestures.\nTo the offering placed with awareness.\nTo inhabited silence.\nTo daily presence."
    },
    p5: {
      fr: "Ici, nous ne cherchons pas à devenir « plus spirituel·le ».",
      en: "Here, we are not trying to become \"more spiritual.\""
    },
    p6: {
      fr: "Nous redécouvrons le sacré dans la vie de tous les jours.",
      en: "We rediscover the sacred in everyday life."
    },
    p7: {
      fr: "La spiritualité non pas comme un concept,\nmais comme une posture.",
      en: "Spirituality not as a concept,\nbut as a posture."
    },
    p8: {
      fr: "Une manière d'habiter son corps.\nDe parler.\nDe choisir.\nDe respirer.",
      en: "A way of inhabiting the body.\nOf speaking.\nOf choosing.\nOf breathing."
    },
    p9: {
      fr: "Un chemin vers plus de stabilité.\nPlus de justesse.\nPlus d'alignement.",
      en: "A path toward greater stability.\nGreater clarity.\nGreater alignment."
    },
    signature: {
      fr: "Et lorsque l'on honore une terre vivante,\nelle nous transforme en retour.",
      en: "And when one honors a living land,\nit transforms us in return."
    }
  },

  // LA TRAVERSÉE / THE JOURNEY SECTION
  journey: {
    label: { fr: "La traversée", en: "The journey" },
    threeMovements: {
      fr: "Trois mouvements structurés.<br />Un arc cohérent.<br />Une expérience signature.",
      en: "Three structured movements.<br />One coherent arc.<br />A signature experience."
    },
    dates: { fr: "25 mai — 9 juin 2026", en: "May 25 – June 9, 2026" },
    nagePrieRayonne: { fr: "NAGE · PRIE · RAYONNE", en: "SWIM · PRAY · RADIATE" },
    fullArc: { fr: "Arc complet", en: "Full arc" }
  },

  // ARC COMPLET SECTION DETAILS
  arcComplet: {
    signatureExperience: { fr: "Expérience signature", en: "SIGNATURE EXPERIENCE" },
    initiatory: { fr: "Traversée intégrale", en: "Complete journey" },
    territories: { fr: "4 territoires.<br />3 îles.<br />Une traversée intégrale.", en: "4 territories.<br />3 islands.<br />One complete journey." },
    duration: { fr: "16 jours · 15 nuits", en: "16 days · 15 nights" },
    durationLabel: { fr: "Durée", en: "DURATION" },
    selectedAccommodations: { fr: "HÉBERGEMENTS SÉLECTIONNÉS", en: "SELECTED ACCOMMODATIONS" },
    whatIncludes: { fr: "Ce que comprend NAGE · PRIE · RAYONNE", en: "What SWIM · PRAY · RADIATE includes" },
    whatIncludesIntro: { 
      fr: "Cette traversée constitue l'architecture complète de COCON SACRÉ.<br />Chaque étape est réservée, structurée et orchestrée à l'avance.",
      en: "This journey forms the complete architecture of COCON SACRÉ.<br />Each stage is reserved, structured and orchestrated in advance."
    },
    experienceIncludes: { fr: "L'expérience comprend :", en: "The experience includes:" },
    includes: {
      nights: { fr: "15 nuits dans les établissements sélectionnés", en: "15 nights in the selected accommodations" },
      rooms: { fr: "Hébergement en chambre individuelle ou partagée selon votre choix", en: "Accommodation in single or twin-shared rooms depending on your choice" },
      transfers: { fr: "Tous les transferts terrestres et maritimes", en: "All land and sea transfers" },
      hotelNight: { fr: "1 nuit d'hôtel le 5 juin (transition inter-îles) incluse", en: "One hotel night on June 5 (inter-island transition) included" },
      flight: { fr: "Vol interne Bali → Java inclus", en: "Internal flight Bali → Java included" },
      javaTransfers: { fr: "Tous les transferts à Java inclus", en: "All transfers in Java included" },
      meals: { fr: "Brunchs sacrés quotidiens & dîners inclus", en: "Daily sacred brunch & dinners included" },
      spaces: { fr: "Accès aux espaces privés et naturels de chaque lieu", en: "Access to the private and natural spaces of each location" },
      ceremonies: { fr: "Cérémonies confirmées dans des lieux traditionnels préservés", en: "Ceremonies confirmed in preserved traditional settings" },
      priestess: { fr: "Rencontre avec la High Priestess de Bali", en: "Meeting with the High Priestess of Bali" },
      massage: { fr: "2h30 de massage balinais inclus", en: "2h30 of Balinese massage included" },
      guidance: { fr: "Accompagnement structuré du premier au dernier jour", en: "Structured guidance from the first to the last day" }
    },
    humanGuidance: { fr: "ACCOMPAGNEMENT HUMAIN", en: "HUMAN GUIDANCE" },
    humanGuidanceItems: {
      presence: { fr: "Présence continue de Jeinar et des Coconeuses", en: "Continuous presence of Jeinar and the Coconeuses" },
      practitioners: { fr: "5 femmes-médecines co-facilitent la traversée", en: "5 women-medicine practitioners co-facilitating the journey" },
      photographer: { fr: "Photographe & vidéaste professionnel·le·s présent·e·s tout le long de la retraite", en: "Professional photographer & videographer present throughout the retreat" }
    },
    integralExperience: {
      fr: "Une expérience intégrale.<br />Rare dans son accès.<br />Précise dans sa structure.<br />Durable dans ses effets.",
      en: "An integral experience.<br />Rare in its access.<br />Precise in its structure.<br />Enduring in its effects."
    },
    format: { fr: "FORMAT", en: "FORMAT" },
    formatText: {
      fr: "Groupe réduit confirmé.<br />Accès relationnel privilégié.<br />Une expérience non reproductible à grande échelle.",
      en: "Confirmed small group.<br />Privileged relational access.<br />An experience that cannot be reproduced at large scale."
    },
    engagement: { fr: "ENGAGEMENT", en: "COMMITMENT" },
    engagementText: {
      fr: "Les places sont limitées.<br />Toute inscription confirme et valide immédiatement la réservation.",
      en: "Places are limited.<br />Any registration confirms and immediately validates the reservation."
    }
  },

  // NAGE PRIE SECTION
  nagePrie: {
    label: { fr: "Ouverture & Cœur", en: "Opening & Heart" },
    title: { fr: "NAGE · PRIE", en: "SWIM · PRAY" },
    subtitle: { fr: "Traversée initiatique", en: "Initiatory journey" },
    dates: { fr: "25 mai — 5 juin 2026", en: "May 25 – June 5, 2026" },
    duration: { fr: "12 jours · 11 nuits", en: "12 days · 11 nights" },
    territories: { fr: "3 territoires.", en: "3 territories." },
    whatIncludes: { fr: "Ce que comprend NAGE · PRIE", en: "What SWIM · PRAY includes" }
  },

  // PRIE RAYONNE SECTION
  prieRayonne: {
    label: { fr: "Cœur & Intégration", en: "Heart & Integration" },
    title: { fr: "PRIE · RAYONNE", en: "PRAY · RADIATE" },
    subtitle: { fr: "Traversée initiatique", en: "Initiatory journey" },
    dates: { fr: "28 mai — 9 juin 2026", en: "May 28 – June 9, 2026" },
    duration: { fr: "13 jours · 12 nuits", en: "13 days · 12 nights" },
    whatIncludes: { fr: "Ce que comprend PRIE · RAYONNE", en: "What PRAY · RADIATE includes" }
  },

  // SCHEMA.ORG
  schema: {
    name: {
      fr: "COCON SACRÉ 2026 - Retraite Transformatrice à Bali",
      en: "COCON SACRÉ 2026 – Transformational Retreat in Bali"
    },
    description: {
      fr: "Retraite initiatique à Bali, Ubud et Borobudur. Une expérience signature de transformation profonde. Nage · Prie · Rayonne.",
      en: "An initiatory journey across Gili, Bali and Borobudur. A refined, immersive experience of deep transformation."
    }
  },

  // STICKY NAVIGATION
  nav: {
    arc: { fr: "L'ARC", en: "THE ARC" },
    nage: { fr: "NAGE", en: "SWIM" },
    prie: { fr: "PRIE", en: "PRAY" },
    rayonne: { fr: "RAYONNE", en: "RADIATE" },
    format: { fr: "FORMAT", en: "FORMAT" },
    reserver: { fr: "RÉSERVER", en: "ENTER THE JOURNEY" }
  },

  // HERO SECTION
  hero: {
    subtitle: {
      fr: "RETRAITE INITIATIQUE",
      en: "INITIATORY RETREAT"
    },
    title: {
      fr: "COCON SACRÉ",
      en: "COCON SACRÉ"
    },
    tagline: {
      fr: "Nage · Prie · Rayonne",
      en: "SWIM · PRAY · RADIATE ·"
    },
    location: {
      fr: "GILI MENO · BALI · JAVA",
      en: "GILI MENO · BALI · JAVA"
    },
    date: {
      fr: "MAI – JUIN 2026",
      en: "MAY – JUNE 2026"
    },
    // Primary CTA button
    ctaButton: {
      fr: "Je choisis ma traversée",
      en: "ENTER THE JOURNEY"
    }
  },

  // TRANSITION - Bridge sentence before retreat cards
  transitionBridge: {
    line1: {
      fr: "Les retraites COCON sont des espaces de traversée.",
      en: "COCON retreats are passages of transformation."
    },
    line2: {
      fr: "Tu n'y viens pas consommer une expérience : tu y viens te rencontrer.",
      en: "You are not coming to consume an experience:<br />you are coming to meet yourself."
    }
  },

  // EMOTIONAL TRANSITION - Before choosing retreat
  emotionalTransition: {
    p1: {
      fr: "Si quelque chose en toi s'ouvre en lisant ces lignes,<br />prends un instant.",
      en: "If something inside you opens while reading these lines,<br />take a moment."
    },
    p2: {
      fr: "Peut-être que ce voyage t'appelle déjà.",
      en: "Perhaps this journey is already calling you."
    },
    p3: {
      fr: "Tu peux maintenant découvrir les différentes traversées possibles.",
      en: "You can now explore the different paths of the retreat."
    }
  },

  // SECTION - Choose your path
  chooseSection: {
    title: {
      fr: "Ta traversée",
      en: "CHOOSE YOUR PATH"
    },
    orientationLine: {
      fr: "Choisis la durée qui respecte ton rythme.",
      en: "Choose the duration that honours your rhythm."
    }
  },

  // THE INITIATORY ARC
  arc: {
    title: {
      fr: "L'Arc Initiatique",
      en: "The Initiatory Arc"
    },
    subtitle: {
      fr: "NAGE · PRIE · RAYONNE",
      en: "SWIM · PRAY · RADIATE"
    },
    intro: {
      fr: "Trois mouvements.\nUn seul arc.\n\nCOCON SACRÉ 2026 se vit en trois temps successifs.\nChaque étape prépare la suivante.\nRien n'est décoratif.\nTout est orchestré.",
      en: "Three movements.\nOne arc.\n\nCOCON SACRÉ 2026 unfolds in three successive phases.\nEach stage prepares the next.\nNothing is decorative.\nEverything is orchestrated."
    },
    quote: {
      fr: "« On ne traverse pas COCON comme on consomme une retraite.\nOn entre dans un processus. On en ressort autrement. »",
      en: "\"We do not move through COCON as one consumes a retreat.\nWe enter a process. We leave transformed.\""
    }
  },

  // THREE MOVEMENTS COLUMNS
  movements: {
    nage: {
      title: { fr: "NAGE", en: "SWIM" },
      location: { fr: "Gili Meno", en: "Gili Meno" },
      dates: { fr: "25 – 28 mai 2026", en: "May 25 – 28, 2026" },
      description: {
        fr: "Silence, immersion, lâcher-prise.\nQuatre jours sur une île sans voiture, sans bruit, face à la mer.\nOn ne commence pas COCON en parlant.\nOn commence en écoutant.",
        en: "Silence. Immersion. Release.\nFour days on a motor-free island, facing the sea.\n\nCOCON does not begin with speaking.\nIt begins with listening."
      }
    },
    prie: {
      title: { fr: "PRIE", en: "PRAY" },
      location: { fr: "Bali · Ubud", en: "Bali · Ubud" },
      dates: { fr: "28 mai – 5 juin 2026", en: "May 28 – June 5, 2026" },
      description: {
        fr: "Rituels, cercles, cérémonies.\nHuit jours au cœur spirituel de Bali.\nOn entre dans le travail sacré.\nOn traverse ce qui doit être traversé.",
        en: "Rituals. Circles. Ceremonies.\nEight days at the spiritual heart of Bali.\n\nThis is where the work truly begins.\nWe enter the sacred field.\nWe cross what needs to be crossed."
      }
    },
    rayonne: {
      title: { fr: "RAYONNE", en: "RADIATE" },
      location: { fr: "Java · Borobudur", en: "Java · Borobudur" },
      dates: { fr: "5 – 9 juin 2026", en: "June 5 – 9, 2026" },
      description: {
        fr: "Intégration, consécration, transmission.\nQuatre jours face au plus grand temple bouddhiste du monde.\nOn ne repart pas.\nOn rayonne.",
        en: "Integration. Consecration. Transmission.\nFour days facing the largest Buddhist temple in the world.\n\nWe do not simply return.\nWe RADIATE."
      }
    }
  },

  // NAGE DETAILED
  nageDetail: {
    title: { fr: "NAGE", en: "SWIM" },
    subtitle: { fr: "GILI MENO · 25 – 28 MAI 2026", en: "GILI MENO · MAY 25 – 28, 2026" },
    sectionTitle: { fr: "Ouverture & Immersion", en: "Opening & Immersion" },
    p1: {
      fr: "Avant de parler, on écoute.\nAvant de traverser, on s'ouvre.",
      en: "Before speaking, we listen.\nBefore crossing, we open."
    },
    p2: {
      fr: "NAGE est le premier mouvement de COCON SACRÉ.\nQuatre jours sur une île sans moteur, sans voiture, sans bruit.\nFace à la mer.\nFace à soi.",
      en: "SWIM is the first movement of COCON SACRÉ.\nFour days on an island without engines, without traffic, without noise.\nFacing the sea.\nFacing oneself."
    },
    p3: {
      fr: "Ce n'est pas une mise en bouche.\nC'est une mise en présence.",
      en: "This is not a warm-up.\nIt is a reset."
    },
    p4: {
      fr: "Un sas de décompression réelle\navant d'entrer dans le cœur du travail.",
      en: "A true decompression chamber\nbefore entering the depth of the work."
    },
    listTitle: { fr: "Ce qui vous attend :", en: "What awaits you:" },
    listItems: {
      fr: [
        "Pratiques d'ancrage face à l'océan",
        "Marches silencieuses au lever du jour",
        "Temps de repos, de lecture, de contemplation",
        "Première cérémonie d'ouverture du cercle",
        "Hébergement face mer dans un cadre préservé"
      ],
      en: [
        "Grounding practices facing the ocean",
        "Silent sunrise walks",
        "Rest, reading, contemplation",
        "Opening ceremony of the circle",
        "Seafront accommodation in a preserved setting"
      ]
    }
  },

  // PRIE DETAILED
  prieDetail: {
    title: { fr: "PRIE", en: "PRAY" },
    subtitle: { fr: "BALI · UBUD · 28 MAI – 5 JUIN 2026", en: "BALI · UBUD · MAY 28 – JUNE 5, 2026" },
    sectionTitle: { fr: "Traversée & Transformation", en: "Journey & Transformation" },
    p1: {
      fr: "PRIE est le cœur de COCON SACRÉ.\nHuit jours au centre spirituel de Bali.",
      en: "PRAY is the heart of COCON SACRÉ.\nEight days in the spiritual center of Bali."
    },
    p2: {
      fr: "C'est ici que le travail commence vraiment.",
      en: "This is where the process deepens."
    },
    p3: {
      fr: "On entre dans les cercles.\nOn traverse ce qui demande à être traversé.\nOn ne fuit plus.",
      en: "We enter the circles.\nWe cross what asks to be crossed.\nWe stop avoiding."
    },
    p4: {
      fr: "PRIE n'est pas une accumulation d'activités.\nC'est un espace où le sacré opère — dans le silence comme dans l'intensité.",
      en: "PRAY is not an accumulation of activities.\nIt is a sacred field — operating in silence as much as in intensity."
    },
    listTitle: { fr: "Ce qui vous attend :", en: "What awaits you:" },
    listItems: {
      fr: [
        "Cérémonies guidées par des prêtresses balinaises",
        "Cercles de parole et d'écoute profonde",
        "Pratiques corporelles douces (pas de performance)",
        "Temps de repos intégrés au rythme de chacune",
        "Soins traditionnels (massage balinais, bains de fleurs)",
        "Visites de temples sacrés hors des circuits touristiques",
        "Nuits dans une villa privatisée au cœur des rizières",
        "Repas vivants préparés avec conscience",
        "Cercle face au volcan Merapi",
        "Présence continue de Jeinar & des Coconeuses"
      ],
      en: [
        "Ceremonies guided by Balinese priestesses",
        "Deep listening and speaking circles",
        "Gentle embodied practices (no performance)",
        "Integrated rest periods",
        "Traditional treatments (Balinese massage, flower baths)",
        "Sacred temple visits outside touristic routes",
        "Private villa stay amidst rice fields",
        "Conscious, nourishing meals",
        "Circle facing Mount Merapi",
        "Continuous presence of Jeinar & the Coconeuses"
      ]
    }
  },

  // PRIE RAYONNE DETAILED
  prieRayonneDetail: {
    title: { fr: "PRIE · RAYONNE", en: "PRAY · RADIATE" },
    subtitle: { fr: "BALI · JAVA · 28 MAI – 9 JUIN 2026", en: "BALI · JAVA · MAY 28 – JUNE 9, 2026" },
    p1: {
      fr: "Deux mouvements.\nUne traversée complète du cœur à la lumière.",
      en: "Two movements.\nA complete journey from heart to light."
    },
    p2: {
      fr: "Vous commencez par PRIE — le travail profond, les cercles, les rituels au cœur de Bali.\nPuis vous enchaînez avec RAYONNE — l'intégration et la consécration à Java, face à Borobudur.",
      en: "You begin with PRAY — deep work, rituals, circles at the heart of Bali.\nThen continue with RADIATE — integration and consecration in Java, facing Borobudur."
    },
    p3: {
      fr: "Cette formule est pensée pour celles qui veulent aller au bout de l'arc sans la phase d'ouverture maritime.",
      en: "This format is designed for those who wish to experience the full arc\nwithout the maritime opening phase."
    },
    p4: {
      fr: "Elle commence directement dans l'intensité.\nEt se termine dans la clarté.",
      en: "It begins directly in intensity.\nIt completes in clarity."
    }
  },

  // RAYONNE DETAILED
  rayonneDetail: {
    title: { fr: "RAYONNE", en: "RADIATE" },
    subtitle: { fr: "JAVA · BOROBUDUR · 5 – 9 JUIN 2026", en: "JAVA · BOROBUDUR · JUNE 5 – 9, 2026" },
    sectionTitle: { fr: "Intégration & Consécration", en: "Integration & Consecration" },
    p1: {
      fr: "RAYONNE est le dernier mouvement.\nCelui où tout prend sens.",
      en: "RADIATE is the final movement.\nWhere everything finds its coherence."
    },
    p2: {
      fr: "Après NAGE.\nAprès PRIE.\nVient le temps de rayonner.",
      en: "After SWIM.\nAfter PRAY.\nComes the moment to RADIATE."
    },
    p3: {
      fr: "Quatre jours à Java.\nFace au plus grand temple bouddhiste du monde.",
      en: "Four days in Java.\nFacing the largest Buddhist temple in the world."
    },
    p4: {
      fr: "RAYONNE n'est pas une \"conclusion\".\nC'est une consécration.",
      en: "RADIATE is not a conclusion.\nIt is a consecration."
    },
    p5: {
      fr: "On intègre ce qui a été traversé.\nOn dépose ce qui n'a plus besoin d'être porté.\nOn repart — alignée, stable, claire.",
      en: "We integrate what has been crossed.\nWe release what no longer needs to be carried.\nWe return aligned, stable, clear."
    },
    quote: {
      fr: "Ce n'est pas une fin.\nC'est un nouveau commencement.",
      en: "This is not an ending.\nIt is a beginning."
    },
    listTitle: { fr: "Ce qui vous attend :", en: "What awaits you:" },
    listItems: {
      fr: [
        "Lever de soleil privé à Borobudur",
        "Cérémonie de clôture face au temple",
        "Dernier cercle de transmission",
        "Temps d'écriture, de silence, de contemplation",
        "Hébergement dans une maison d'exception face aux rizières"
      ],
      en: [
        "Private sunrise at Borobudur",
        "Closing ceremony facing the temple",
        "Final transmission circle",
        "Writing, silence, contemplation",
        "Exceptional residence facing rice fields"
      ]
    }
  },

  // FORMAT SECTION
  format: {
    title: { fr: "Format", en: "Format" },
    subtitle: { fr: "NAGE · PRIE · RAYONNE · 2026", en: "SWIM · PRAY · RADIATE · 2026" },
    intro: {
      fr: "COCON SACRÉ 2026 propose trois formats.\nTrois manières d'entrer dans l'arc.",
      en: "COCON SACRÉ 2026 offers three formats.\nThree ways to enter the arc."
    },
    cards: {
      arcComplet: {
        badge: { fr: "Arc Complet", en: "Complete Arc" },
        title: { fr: "NAGE · PRIE · RAYONNE", en: "SWIM · PRAY · RADIATE" },
        description: {
          fr: "L'intégralité de la traversée.\nDe l'ouverture à la consécration.\n\nGili Meno → Bali → Java\n25 mai – 9 juin 2026",
          en: "The complete journey.\nFrom opening to consecration.\n\nGili Meno → Bali → Java\nMay 25 – June 9, 2026"
        }
      },
      nagePrie: {
        title: { fr: "NAGE · PRIE", en: "SWIM · PRAY" },
        description: {
          fr: "Ouverture et transformation.\nSans la phase finale à Java.\n\nGili Meno → Bali\n25 mai – 5 juin 2026",
          en: "Opening and transformation.\nWithout the final Java phase.\n\nGili Meno → Bali\nMay 25 – June 5, 2026"
        }
      },
      prieRayonne: {
        title: { fr: "PRIE · RAYONNE", en: "PRAY · RADIATE" },
        description: {
          fr: "Transformation et consécration.\nDirectement dans l'intensité.\n\nBali → Java\n28 mai – 9 juin 2026",
          en: "Transformation and consecration.\nDirectly into the depth.\n\nBali → Java\nMay 28 – June 9, 2026"
        }
      }
    }
  },

  // BOOKING BUTTONS
  buttons: {
    nagePrieRayonne: { fr: "· NAGE · PRIE · RAYONNE ·", en: "· SWIM · PRAY · RADIATE ·" },
    nagePrie: { fr: "· NAGE · PRIE ·", en: "· SWIM · PRAY ·" },
    prieRayonne: { fr: "· PRIE · RAYONNE ·", en: "· PRAY · RADIATE ·" }
  },

  // LOADING MESSAGE
  loading: {
    title: {
      fr: "Ta réservation en un clin d'œil",
      en: "Preparing your journey…"
    },
    subtitle: {
      fr: "Chargement en cours...",
      en: "Please wait a moment."
    }
  },

  // PREVIOUS EDITIONS
  previousEditions: {
    title: { fr: "Découvrir les éditions précédentes", en: "Discover previous editions" },
    link: { fr: "Découvrir COCON VALOUSE 2025 →", en: "Discover COCON VALOUSE 2025 →" }
  },

  // MENU SKELETON
  menu: {
    chooseJourney: { fr: "Choisir sa traversée", en: "Choose your journey" },
    signatureExperience: { fr: "Expérience signature", en: "Signature experience" },
    nagePrieRayonne: { fr: "Nage · Prie · Rayonne", en: "SWIM · PRAY · RADIATE ·" },
    arcDates: { fr: "25 mai — 9 juin 2026", en: "May 25 — June 9, 2026" },
    arcDuration: { fr: "16 jours · 15 nuits", en: "16 days · 15 nights" },
    fullArc: { fr: "Arc complet", en: "Full arc" },
    openingHeart: { fr: "Ouverture & Cœur", en: "Opening & Heart" },
    nagePrie: { fr: "Nage · Prie", en: "SWIM · PRAY ·" },
    nagePrieDates: { fr: "25 mai — 5 juin 2026", en: "May 25 — June 5, 2026" },
    nagePrieDuration: { fr: "12 jours · 11 nuits", en: "12 days · 11 nights" },
    heartIntegration: { fr: "Cœur & Intégration", en: "Heart & Integration" },
    prieRayonne: { fr: "Prie · Rayonne", en: "PRAY · RADIATE ·" },
    prieRayonneDates: { fr: "28 mai — 9 juin 2026", en: "May 28 — June 9, 2026" },
    prieRayonneDuration: { fr: "13 jours · 12 nuits", en: "13 days · 12 nights" },
    discover: { fr: "Découvrir", en: "Discover" }
  },

  // BACK LINK
  back: { fr: "Retour", en: "Back" },

  // BEFORE YOU CHOOSE - REASSURANCE BLOCK
  beforeYouBook: {
    title: { fr: "Avant de réserver", en: "Before you choose" },
    p1: { 
      fr: "Si tu lis ces lignes et que quelque chose en toi s'ouvre, c'est souvent le signe que cette traversée pourrait te correspondre.", 
      en: "If you are reading these lines and something within you is opening, it is often a sign that this journey may resonate with you." 
    },
    p2: { 
      fr: "Tu n'as pas besoin d'être expérimenté·e en méditation, en yoga ou en pratiques spirituelles.", 
      en: "You do not need experience in meditation, yoga or spiritual practices." 
    },
    p3: { 
      fr: "Les retraites COCON accueillent simplement des personnes qui sentent l'élan de ralentir, d'écouter et de traverser une étape de leur vie avec conscience.", 
      en: "COCON retreats simply welcome people who feel the desire to slow down, listen deeply and move through a moment of life with greater awareness." 
    },
    p4: { 
      fr: "Si tu ressens cet appel, alors nous pourrons marcher ce chemin ensemble.", 
      en: "If you feel that call, then we may walk this path together." 
    }
  }
};

export default explorerTranslations;
